/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as publicPublicRouteImport } from './routes/(public)/_public'
import { Route as authRegisterRouteImport } from './routes/(auth)/register'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard'
import { Route as publicPublicIndexRouteImport } from './routes/(public)/_public/index'
import { Route as appDashboardIndexRouteImport } from './routes/(app)/dashboard/index'
import { Route as publicPublicFeaturesRouteImport } from './routes/(public)/_public/features'
import { Route as publicPublicDocsRouteImport } from './routes/(public)/_public/docs'
import { Route as appDashboardTodosRouteImport } from './routes/(app)/dashboard/todos'
import { Route as appDashboardSettingsRouteImport } from './routes/(app)/dashboard/settings'
import { Route as appDashboardTodosIndexRouteImport } from './routes/(app)/dashboard/todos/index'
import { Route as appDashboardSettingsIndexRouteImport } from './routes/(app)/dashboard/settings/index'
import { Route as appDashboardTodosNewRouteImport } from './routes/(app)/dashboard/todos/new'
import { Route as appDashboardSettingsUserProfileRouteImport } from './routes/(app)/dashboard/settings/user-profile'
import { Route as appDashboardSettingsChangePasswordRouteImport } from './routes/(app)/dashboard/settings/change-password'
import { Route as appDashboardTodosEditIdRouteImport } from './routes/(app)/dashboard/todos/edit/$id'
import { Route as appDashboardTodosDetailIdRouteImport } from './routes/(app)/dashboard/todos/detail/$id'

const publicPublicRoute = publicPublicRouteImport.update({
  id: '/(public)/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const appDashboardRoute = appDashboardRouteImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const publicPublicIndexRoute = publicPublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)
const appDashboardIndexRoute = appDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)
const publicPublicFeaturesRoute = publicPublicFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicDocsRoute = publicPublicDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => publicPublicRoute,
} as any)
const appDashboardTodosRoute = appDashboardTodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardSettingsRoute = appDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTodosIndexRoute = appDashboardTodosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardTodosRoute,
} as any)
const appDashboardSettingsIndexRoute =
  appDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardTodosNewRoute = appDashboardTodosNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => appDashboardTodosRoute,
} as any)
const appDashboardSettingsUserProfileRoute =
  appDashboardSettingsUserProfileRouteImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsChangePasswordRoute =
  appDashboardSettingsChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardTodosEditIdRoute = appDashboardTodosEditIdRouteImport.update({
  id: '/edit/$id',
  path: '/edit/$id',
  getParentRoute: () => appDashboardTodosRoute,
} as any)
const appDashboardTodosDetailIdRoute =
  appDashboardTodosDetailIdRouteImport.update({
    id: '/detail/$id',
    path: '/detail/$id',
    getParentRoute: () => appDashboardTodosRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/dashboard': typeof appDashboardRouteWithChildren
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/dashboard/todos': typeof appDashboardTodosRouteWithChildren
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/dashboard/todos/': typeof appDashboardTodosIndexRoute
  '/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/dashboard/settings': typeof appDashboardSettingsIndexRoute
  '/dashboard/todos': typeof appDashboardTodosIndexRoute
  '/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(app)/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/(app)/dashboard/todos': typeof appDashboardTodosRouteWithChildren
  '/(public)/_public/docs': typeof publicPublicDocsRoute
  '/(public)/_public/features': typeof publicPublicFeaturesRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(app)/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/(app)/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/(app)/dashboard/todos/new': typeof appDashboardTodosNewRoute
  '/(app)/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/(app)/dashboard/todos/': typeof appDashboardTodosIndexRoute
  '/(app)/dashboard/todos/detail/$id': typeof appDashboardTodosDetailIdRoute
  '/(app)/dashboard/todos/edit/$id': typeof appDashboardTodosEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/login'
    | '/register'
    | '/dashboard/settings'
    | '/dashboard/todos'
    | '/docs'
    | '/features'
    | '/dashboard/'
    | '/'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/dashboard/todos/new'
    | '/dashboard/settings/'
    | '/dashboard/todos/'
    | '/dashboard/todos/detail/$id'
    | '/dashboard/todos/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/docs'
    | '/features'
    | '/dashboard'
    | '/'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/dashboard/todos/new'
    | '/dashboard/settings'
    | '/dashboard/todos'
    | '/dashboard/todos/detail/$id'
    | '/dashboard/todos/edit/$id'
  id:
    | '__root__'
    | '/(app)/dashboard'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(public)/_public'
    | '/(app)/dashboard/settings'
    | '/(app)/dashboard/todos'
    | '/(public)/_public/docs'
    | '/(public)/_public/features'
    | '/(app)/dashboard/'
    | '/(public)/_public/'
    | '/(app)/dashboard/settings/change-password'
    | '/(app)/dashboard/settings/user-profile'
    | '/(app)/dashboard/todos/new'
    | '/(app)/dashboard/settings/'
    | '/(app)/dashboard/todos/'
    | '/(app)/dashboard/todos/detail/$id'
    | '/(app)/dashboard/todos/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appDashboardRoute: typeof appDashboardRouteWithChildren
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(public)/_public': {
      id: '/(public)/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(public)/_public/features': {
      id: '/(public)/_public/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicPublicFeaturesRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/docs': {
      id: '/(public)/_public/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof publicPublicDocsRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(app)/dashboard/todos': {
      id: '/(app)/dashboard/todos'
      path: '/todos'
      fullPath: '/dashboard/todos'
      preLoaderRoute: typeof appDashboardTodosRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/settings': {
      id: '/(app)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof appDashboardSettingsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/todos/': {
      id: '/(app)/dashboard/todos/'
      path: '/'
      fullPath: '/dashboard/todos/'
      preLoaderRoute: typeof appDashboardTodosIndexRouteImport
      parentRoute: typeof appDashboardTodosRoute
    }
    '/(app)/dashboard/settings/': {
      id: '/(app)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof appDashboardSettingsIndexRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/todos/new': {
      id: '/(app)/dashboard/todos/new'
      path: '/new'
      fullPath: '/dashboard/todos/new'
      preLoaderRoute: typeof appDashboardTodosNewRouteImport
      parentRoute: typeof appDashboardTodosRoute
    }
    '/(app)/dashboard/settings/user-profile': {
      id: '/(app)/dashboard/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/settings/user-profile'
      preLoaderRoute: typeof appDashboardSettingsUserProfileRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/change-password': {
      id: '/(app)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof appDashboardSettingsChangePasswordRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/todos/edit/$id': {
      id: '/(app)/dashboard/todos/edit/$id'
      path: '/edit/$id'
      fullPath: '/dashboard/todos/edit/$id'
      preLoaderRoute: typeof appDashboardTodosEditIdRouteImport
      parentRoute: typeof appDashboardTodosRoute
    }
    '/(app)/dashboard/todos/detail/$id': {
      id: '/(app)/dashboard/todos/detail/$id'
      path: '/detail/$id'
      fullPath: '/dashboard/todos/detail/$id'
      preLoaderRoute: typeof appDashboardTodosDetailIdRouteImport
      parentRoute: typeof appDashboardTodosRoute
    }
  }
}

interface appDashboardSettingsRouteChildren {
  appDashboardSettingsChangePasswordRoute: typeof appDashboardSettingsChangePasswordRoute
  appDashboardSettingsUserProfileRoute: typeof appDashboardSettingsUserProfileRoute
  appDashboardSettingsIndexRoute: typeof appDashboardSettingsIndexRoute
}

const appDashboardSettingsRouteChildren: appDashboardSettingsRouteChildren = {
  appDashboardSettingsChangePasswordRoute:
    appDashboardSettingsChangePasswordRoute,
  appDashboardSettingsUserProfileRoute: appDashboardSettingsUserProfileRoute,
  appDashboardSettingsIndexRoute: appDashboardSettingsIndexRoute,
}

const appDashboardSettingsRouteWithChildren =
  appDashboardSettingsRoute._addFileChildren(appDashboardSettingsRouteChildren)

interface appDashboardTodosRouteChildren {
  appDashboardTodosNewRoute: typeof appDashboardTodosNewRoute
  appDashboardTodosIndexRoute: typeof appDashboardTodosIndexRoute
  appDashboardTodosDetailIdRoute: typeof appDashboardTodosDetailIdRoute
  appDashboardTodosEditIdRoute: typeof appDashboardTodosEditIdRoute
}

const appDashboardTodosRouteChildren: appDashboardTodosRouteChildren = {
  appDashboardTodosNewRoute: appDashboardTodosNewRoute,
  appDashboardTodosIndexRoute: appDashboardTodosIndexRoute,
  appDashboardTodosDetailIdRoute: appDashboardTodosDetailIdRoute,
  appDashboardTodosEditIdRoute: appDashboardTodosEditIdRoute,
}

const appDashboardTodosRouteWithChildren =
  appDashboardTodosRoute._addFileChildren(appDashboardTodosRouteChildren)

interface appDashboardRouteChildren {
  appDashboardSettingsRoute: typeof appDashboardSettingsRouteWithChildren
  appDashboardTodosRoute: typeof appDashboardTodosRouteWithChildren
  appDashboardIndexRoute: typeof appDashboardIndexRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardSettingsRoute: appDashboardSettingsRouteWithChildren,
  appDashboardTodosRoute: appDashboardTodosRouteWithChildren,
  appDashboardIndexRoute: appDashboardIndexRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface publicPublicRouteChildren {
  publicPublicDocsRoute: typeof publicPublicDocsRoute
  publicPublicFeaturesRoute: typeof publicPublicFeaturesRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicDocsRoute: publicPublicDocsRoute,
  publicPublicFeaturesRoute: publicPublicFeaturesRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  appDashboardRoute: appDashboardRouteWithChildren,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  publicPublicRoute: publicPublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
